export const consumables = [
    'Unknown',
    'ThinXXS v1/DG',
    'ThinXXS v2a/DG',
    'ThinXXS v2b/DG',
    'ThinXXS v2c/DG',
    'ThinXXS v2c Dimpled',
    'Weidmann v3/DG',
    'Weidmann v5/DG',
    'Harvard Pump/Chip Shop',
    'Mensor Pump/Chip Shop',
    'Syringe/Chip Shop',
    'Other'
];

export const autoDGPlateTypes = [
    '4-Well ColorComp (ENG)',
    '4-Well ColorComp (MFG)',
    'Auto Validation',
    'Cal Verification (CSFV)',
    'Carryover (ENG)',
    'CNV',
    'CNV (Groove)',
    'DG Pressure Volume',
    'Duplex',
    'Dye',
    'Dye Calibration',
    'Dye v2',
    'EvaGreen Assay DNA Load',
    'EvaGreen DNR (RNaseP)',
    'EvaGreen DNR (Staph/high BG)',
    'EvaGreen DNR (Staph/no BG)',
    'EventCount',
    'Exception',
    'FAM/VIC Titration (Groove)',
    'FAM350 DNA Load',
    'FAM350 no DNA',
    'Fluidics Verification',
    'FP/FN',
    'HighDNR',
    'Other',
    'Qx200 Broad Panel EG val',
    'Qx200 Broad Panel TQ val',
    'Qx200 CNV validation',
    'Qx200 DNR validation',
    'Qx200 Duplex validation',
    'Qx200 EvaGreen CNV val',
    'RED',
    'Singleplex',
    'Two Dye Carryover'
];

export const dgOil = [
    'Unknown',
    'QLF 1.1',
    'QLF 1.3',
    'QLF 1.4',
    'QLF 3.0 (DNA Groove)',
    'QLF 3.1 (DNA Groove)',
    'Other'
];

export const drOil = [

    'Unknown',
    'QLF 2.1',
    'QLF 2.1.1',
    'QLF 2.2',
    'QLF 4.0 (DNA Groove)',
    'Other'
];

export const mastermix = [
    'Unknown',
    'QLMM 0.1',
    'QLMM 0.2',
    'QLMM 1.0',
    'QLMM 1.1',
    'QLMM 1.2 (HEX)',
    'QL 1-step RT-PCR MM',
    'DNA Groove MM 0.2',
    'DNA Groove MM 0.3',
    'EvaGreen MM 0.5',
    'Droplet PCR Supermix',
    'Skinless Taq MM 0.1',
    'Other'
];

export const project = [
    'Unknown',
    'DG Oil QC',
    'Adg Mixing',
    'ADG Pushback',
    'ADG p_holder',
    'ADG131Val',
    'ADG131Val',
    'ADG131Val',
    'aDGParam',
    'ADG_CBA_V2',
    'AutoDG Mfg',
];

export const thermo_cycler = [
    'Unknown',
    'Bio-Rad C1000',
    'Bio-Rad T100 1',
    'Eppendorf 1',
    'Eppendorf 2',
    'Eppendorf 3',
    'Eppendorf 4',
    'Eppendorf 5',
    'Eppendorf 6',
    'Eppendorf 8',
    'Other'
];
